var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { "enter-active-class": "animated fadeIn", duration: 100 } },
    [
      _vm.visible
        ? _c(
            "div",
            {
              ref: "popoverContainer",
              staticClass: "custom-popover",
              attrs: { "data-placement": _vm.placement },
            },
            [_vm._t("default")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }